export const brandVisuals = [
  'Axo Group',
  'axo-finans',
  'axo-laina',
  'lendme',
  'lendme.axo',
  'uloan.axo',
  'uscore',
  'zmarta',
  'zmarta.axo',
  'elskling',
  'freedom-finance',
  'freedom-finance--dark',
  'freedom-rahoitus',
  'freedom-rahoitus--dark',
  'centum',
  'centum.axo'
] as const;

export type BrandVisual = (typeof brandVisuals)[number];
